import { render, staticRenderFns } from "./PendingShipmentsPage.vue?vue&type=template&id=52d843a9"
import script from "./PendingShipmentsPage.vue?vue&type=script&lang=js"
export * from "./PendingShipmentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports